import {RDX_INTL_APPEND } from './intlAction';
import locale from '../i18n';

const initial = {
	...locale
};

const app = (state = initial, action) => {
	let newState = {...state};
	switch (action.type) {
		case RDX_INTL_APPEND :
			for (let lk in newState) {
				newState[lk] = {...newState[lk], ...action.message[lk]};
			}
			return newState;
	
		default:
			return state;
	}
};

export default app;